<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" ref="modalRef">
        <div class="modal-dialog " role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{viewStrings.project_approval_title}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Stäng">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="card-body mb-0">
                        <template v-if="!isSigned">
                            <p class="text">{{viewStrings.project_approval_sign_text}}</p>

                            <component
                                :is="signComponentName"
                                :item-id="itemId"
                                :item-description="signComponentItemDescription"
                                :app-url="appUrl"
                                :quote-key="quoteKey"
                                :signee-name="signComponentSigneeName"
                                :signature-button-label="signComponentSignatureButtonLabel"
                                @signed="onSigned"
                            />
                        </template>
                        <template v-else>
                            <p class="text">{{viewStrings.project_approval_note_text}}</p>

                            <textarea class="form-control mb-3" rows="6" v-model="notes">
                            </textarea>

                            <button v-if="!isSubmittingNotes" class="projectApprovalNoteButton btn btn-secondary" @click="submitNotes">{{submitNotesButtonTitle}}</button>
                            <button v-else type="button" class="btn btn-primary wait">
                            <div class="spinner-border spinner-border-sm mr-2"></div>
                            </button>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
button.btn {
    width: 100%;

    &.wait .spinner-border {
        vertical-align: middle;
    }
}

p.text {
    white-space: pre-line;
}
</style>

<script setup>
import { computed, onMounted, ref } from "vue";
import axios from "axios";
const modalRef = ref(null);
const props = defineProps({
    appUrl: String,
    quoteKey: String,
    itemId: String,
    signComponentName: {
        type: String,
        required: true,
    },
    signComponentSigneeName: {
        type: String,
        default: null,
    },
    signComponentSignatureButtonLabel: {
        type: String,
        required: true,
    },
    signComponentItemDescription: String,
    viewStrings: {
        type: Object,
        required: true,
    },
});
const isSigned = ref(false);
const isSubmittingNotes = ref(false);
const notes = ref("");
const submitNotesButtonTitle = computed(() => {
    if (notes.value) {
        return props.viewStrings.project_approval_note_submit_button_text;
    } else {
        return props.viewStrings.project_approval_note_skip_button_text;
    }
});
function onSigned() {
    isSigned.value = true;
}
async function submitNotes() {
    if (notes.value) {
        try {
            isSubmittingNotes.value = true;
            await axios.put(`/quote/${props.quoteKey}/notes`, {
                notes: notes.value,
            });
        } catch (error) {
            isSubmittingNotes.value = false;
            console.warn("Failed to submit note", error);
            return;
        }
    }
    document.location.reload();
}
onMounted(() => {
    if (new URLSearchParams(document.location.search).get("project_approval")) {
        $(modalRef.value).modal("show");
    }
});
</script>
